<div style="display:flex;justify-content: flex-start;gap:20px;align-items: center;padding-bottom: 20px;" *ngIf="isAbutmentHighlySelected" >
    <div><img src="exclamation.png" height="32" width="auto"></div>
    <div style="font-style: normal;font-weight: 400;font-size: 16px;line-height: 130%;color: #000000;">If soft tissue is limited and the abutment margin is placed subgingivally, the abutment cannot be wide. Placed supragingivally, options like full anatomical dimensions or contour soft tissue allow wider abutments – though parts may remain visible. 
The anatomical support option is unsuitable for shallow implants.</div>
</div>
<div class="radio-cards-container" style="max-width: 100%">
    <label class="radio-card-label-new" (click)="onAabutmentStep1Selection('Narrow healing space')" style="width:30%">
        <input type="radio" name="healing-gingival"
            value="Anatomical connection" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep1','Narrow healing space')" value="Narrow healing space"  />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
            <app-magnifier [contentTemplate]="apppropphtmNarow"></app-magnifier>
                <ng-template #apppropphtmNarow>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                            <img #gbridgestrong id="gbridgestrong"  width="auto" class="p-3" height="180"  src="Asset_Image_Gity_V3/Gingival_Situation/Narrow_Healing_Space.png" />
                        </div>
                        <div class="card-text">Narrow healing space</div>
                     </div>
         </ng-template>
        </div>   
        <div class="radio-card-overlay"></div>
    </label>
    <label class="radio-card-label-new" (click)="onAabutmentStep1Selection('Wide healing space')" style="width:30%">
        <input type="radio" name="healing-gingival" 
            value="Strong connection" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep1','Wide healing space')" value="Wide healing space"/>
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
             <app-magnifier [contentTemplate]="apppropphtmlWide"></app-magnifier>
                <ng-template #apppropphtmlWide>
                <div class="magnify-content magnify-small">
                   <div class="img-center ">
                      <img width="auto" class="p-3" height="180" src="Asset_Image_Gity_V3/Gingival_Situation/Wide_Healing_Space.png" />
                    </div>
                    <div class="card-text">Wide healing space</div>
                </div>
            </ng-template>
        </div>
        <div class="radio-card-overlay"></div>
    </label>
    <label class="radio-card-label-new" (click)="onAabutmentStep1Selection('Highly placed implant')" style="width:30%">
        <input type="radio" name="healing-gingival" 
            value="Very strong connection" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep1','Highly placed implant')" value="Highly placed implant" />
        <div class="custom-radio-indicator">
            <div class="custom-radio-indicator-dot"></div>
        </div>
        <div class="card-icon">
             <app-magnifier [contentTemplate]="apppropphtmHighly"></app-magnifier>
                <ng-template #apppropphtmHighly>
                    <div class="magnify-content magnify-small">
                        <div class="img-center ">
                        <img  width="auto" class="p-3" height="180"   src="Asset_Image_Gity_V3/Gingival_Situation/Highly_Healing_Space.png" />
                    </div>
                     <div class="card-text">Highly placed implant</div>
                </div>
                </ng-template>
        </div>
        <div class="radio-card-overlay"></div>
    </label>
</div>